import { ButtonProps, styled } from '@mui/material';
import ToggleButtonGroup, { ToggleButtonGroupProps }  from '@mui/material/ToggleButtonGroup';
import ToggleButton, { ToggleButtonProps } from '@mui/material/ToggleButton';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import { ComponentType, HTMLAttributes } from 'react';
import StyledCustomButton, { CustomButtonProps } from '@/components/Button';

export const FormTitle: ComponentType<HTMLAttributes<HTMLHeadingElement>> = styled('h2')({
  textAlign: 'center',
  margin: '20px 0 0 0',
  fontWeight: 500,
  fontSize: '20px',
  lineHeight: '23px',
  color: '#000000',
});

export const FormSubTitle: ComponentType<HTMLAttributes<HTMLHeadingElement>> = styled('h3')({
  fontWeight: 500,
  fontSize: '20px',
  lineHeight: '16px',
  color: '#091E42',
  margin: '0px',
});

export const GroupLabel: ComponentType<HTMLAttributes<HTMLHeadingElement>> = styled('h4')({
  margin: '0px',
  fontSize: '14px',
  fontWeight: 700,
  color: '#091E42',
  display: 'flex',
});

export const FormTabsSwitcher: ComponentType<ToggleButtonGroupProps> = styled(ToggleButtonGroup)({
  display: 'flex',
  justifyContent: 'center',
  padding: '15px 20px',
  margin: '0 0 27px 0',
});

export const FormTabButton: ComponentType<ToggleButtonProps> = styled(ToggleButton)({
  margin: '0 !important',
  padding: '8px 14px 8px 14px',
  fontSize: '14px',
  fontWeight: 500,
  textAlign: 'left',
  color: '#0747A6',
  border: 'none',
  borderRadius: 0,
  background: 'transparent !important',
  '&.Mui-selected': {
    border: '1px solid #DFE1E6 !important',
    color: '#091E42',
    borderRadius: '6px !important',
  }
});
export const FormTab: ComponentType<HTMLAttributes<HTMLDivElement>> = styled('div')({
  /*
  marginTop: 20,
  marginBottom: 20,
  */
  padding: '20px',
  flex: '1 1 auto',
  minHeight: 0,
});

export const CustomTextField: ComponentType<Omit<TextFieldProps, 'variants'>> = styled(TextField)({
  '& .MuiInputBase-root': {
    height: '36px',
  },

  '& .MuiInputBase-input': {
    boxSizing: 'border-box',
    //height: '36px',
    padding: '6px 10px',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '16px',
    color: '#091E42',
  },

  '& .MuiInputLabel-outlined': {
    color: '#C1C7D0',
    transform: 'translate(10px, 9px) scale(1)',
  },

  '& .MuiInputLabel-shrink': {
    transform: 'translate(14px, -9px) scale(0.75)',
  },

  '& .MuiOutlinedInput-notchedOutline': {
    border: '1px solid #6B778C',
    borderRadius: '4px',
  }
});

export const FormButton: ComponentType<CustomButtonProps> = styled(StyledCustomButton)({
  padding: '9px 36px',
  height: '32px',
  background: '#0052CC',
  border: '1px solid #0747A6',
  borderRadius: '6px',

  fontWeight: 500,
  fontSize: '12px',
  lineHeight: '14px',
  color: '#FFFFFF',

  '&.Mui-disabled': {
    borderColor: 'rgba(0, 0, 0, 0.12)',
  },
  '& .MuiCircularProgress-root': {
    position: 'static',
  }
});

export const Form: ComponentType<HTMLAttributes<HTMLFormElement>> = styled('form')({
  margin: 'auto',
  display: 'flex',
  flexDirection: 'column',
  gap: '40px',
  flexWrap: 'nowrap',
  justifyContent: 'center',
  height: '100%',
});

export const FormGroup: ComponentType<HTMLAttributes<HTMLDivElement>> = styled('div')({
  display: 'flex',
  width: '50%',
  flexDirection: 'column',
  alignItems: 'center',
  height: '330px',
  gap: 30,
  ':nth-of-type(odd)': {
    borderRight: 'solid 1px #DFE1E6',
  },
  padding: '20px',
});

export const PageSection: ComponentType<HTMLAttributes<HTMLDivElement>> = styled('div')({
  margin: 'auto',
  display: 'flex',
  gap: '10px',
  flexDirection: 'column',
});